import React from 'react';
import DigitalClock from './components/DigitalClock';

function App() {
  return (
    <div>
      <DigitalClock />
    </div>
  );
}

export default App;